import React from 'react';
import EditPaychequeDrawer from '../../../components/EditPaychequeDrawer';
import StatHolidayEligibilityPopup from '../../../components/payroll/StatHolidayEligibilityPopup';
import {
  AdjustStatPayModal,
  MarkNotEligibleModal,
  OverrideEligibleModal,
} from '../../../components/payroll/StatHolidaySubModals';
import ChangePeriodModal from '../../../components/payroll/ChangePeriodModal';
import type { PayRun, StatHolidayOverrides, StatSubModal } from '../types';

/* eslint-disable @typescript-eslint/no-explicit-any */
const EditPaychequeDrawerAny = EditPaychequeDrawer as any;
const StatHolidayEligibilityPopupAny = StatHolidayEligibilityPopup as any;
const AdjustStatPayModalAny = AdjustStatPayModal as any;
const MarkNotEligibleModalAny = MarkNotEligibleModal as any;
const OverrideEligibleModalAny = OverrideEligibleModal as any;
const ChangePeriodModalAny = ChangePeriodModal as any;
/* eslint-enable @typescript-eslint/no-explicit-any */

interface Props {
  payRun: PayRun | null;
  payRunId: string | undefined;

  changePeriodOpen: boolean;
  onChangePeriodCancel: () => void;
  onChangePeriodSaved: (updated: Partial<PayRun>) => void;

  statHolidayPopupOpen: boolean;
  statHolidayOverrides: StatHolidayOverrides;
  onStatPopupCancel: () => void;
  onStatPopupContinue: (overrides: StatHolidayOverrides) => void;
  onOpenAdjust: (emp: any, hol: any) => void;
  onOpenMarkNotEligible: (emp: any, hol: any) => void;
  onOpenOverrideEligible: (emp: any, hol: any) => void;

  statSubModal: StatSubModal | null;
  onCloseStatSub: () => void;
  onStatSubSave: (empId: string | number, patch: any) => void;

  editDrawerEmployeeId: string | number | null;
  onCloseEditDrawer: () => void;
  onEditSaved: () => void;
}

export default function RunPayrollModals({
  payRun, payRunId,
  changePeriodOpen, onChangePeriodCancel, onChangePeriodSaved,
  statHolidayPopupOpen, statHolidayOverrides,
  onStatPopupCancel, onStatPopupContinue,
  onOpenAdjust, onOpenMarkNotEligible, onOpenOverrideEligible,
  statSubModal, onCloseStatSub, onStatSubSave,
  editDrawerEmployeeId, onCloseEditDrawer, onEditSaved,
}: Props) {
  return (
    <>
      {changePeriodOpen && payRun && (
        <ChangePeriodModalAny
          isOpen={true}
          payRun={payRun}
          onCancel={onChangePeriodCancel}
          onSaved={onChangePeriodSaved}
        />
      )}
      {statHolidayPopupOpen && payRun && (
        <StatHolidayEligibilityPopupAny
          periodStart={payRun.pay_period_start}
          periodEnd={payRun.pay_period_end}
          subnational="AB"
          overrides={statHolidayOverrides}
          onCancel={onStatPopupCancel}
          onContinue={onStatPopupContinue}
          onOpenAdjust={onOpenAdjust}
          onOpenMarkNotEligible={onOpenMarkNotEligible}
          onOpenOverrideEligible={onOpenOverrideEligible}
        />
      )}
      {statSubModal && statSubModal.type === 'adjust' && (
        <AdjustStatPayModalAny
          isOpen={true}
          emp={statSubModal.emp}
          holiday={statSubModal.hol}
          onCancel={onCloseStatSub}
          onSave={(patch: any) => onStatSubSave(statSubModal.emp.employee_id, patch)}
        />
      )}
      {statSubModal && statSubModal.type === 'not_eligible' && (
        <MarkNotEligibleModalAny
          isOpen={true}
          emp={statSubModal.emp}
          holiday={statSubModal.hol}
          onCancel={onCloseStatSub}
          onConfirm={(patch: any) => onStatSubSave(statSubModal.emp.employee_id, patch)}
        />
      )}
      {statSubModal && statSubModal.type === 'override_eligible' && (
        <OverrideEligibleModalAny
          isOpen={true}
          emp={statSubModal.emp}
          holiday={statSubModal.hol}
          onCancel={onCloseStatSub}
          onConfirm={(patch: any) => onStatSubSave(statSubModal.emp.employee_id, patch)}
        />
      )}
      {editDrawerEmployeeId && (
        <EditPaychequeDrawerAny
          runId={payRunId}
          employeeId={editDrawerEmployeeId}
          onClose={onCloseEditDrawer}
          onSaved={onEditSaved}
        />
      )}
    </>
  );
}